/**
 * @generated SignedSource<<5f00b0c63b413a0931620577d50bea32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSelectQuantity_transaction$data = {
  readonly sku: {
    readonly availableQuantity: number | null;
    readonly hasUnlimitedQuantity: boolean | null;
    readonly quantitySelectOptions: ReadonlyArray<{
      readonly label: string | null;
      readonly value: number | null;
    } | null> | null;
    readonly setSize: number | null;
  } | null;
  readonly " $fragmentType": "CheckoutSelectQuantity_transaction";
};
export type CheckoutSelectQuantity_transaction$key = {
  readonly " $data"?: CheckoutSelectQuantity_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSelectQuantity_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSelectQuantity_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "sku",
      "plural": false,
      "selections": [
        {
          "alias": "availableQuantity",
          "args": null,
          "kind": "ScalarField",
          "name": "quantity",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasUnlimitedQuantity",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SkuQuantityOption",
          "kind": "LinkedField",
          "name": "quantitySelectOptions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "setSize",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "e59ed5b43282efc6528472b98ed8cdcb";

export default node;
